import {FC, useMemo} from 'react';
import cx from 'classnames';
//mui
import {
	Dropdown as MuiDropdown,
	Menu as MuiMenu,
	MenuButton as MuiMenuButton,
	MenuItem as MuiMenuItem,
} from '@mui/base';
import {Box, Typography} from '@mui/material';
//icons
import {ReactComponent as ArrowUpIcon} from '@/assets/icons/arrow-up.svg';
import {ReactComponent as ArrowLeftIcon} from '@/assets/icons/arrow-left.svg';
import {ReactComponent as ArrowRightIcon} from '@/assets/icons/arrow-right.svg';
//constants
import {BODY1, TEXT, UL, defaultPage} from '@/utils/constants';
//components
import Button from '../Button';
//styles
import styles from './styles.module.scss';

interface PaginationProps {
	page: number;
	pageSize: number;
	total: number;
	onChange: (page: number) => void;
	displayMode?: 'page' | 'range';
}

const Pagination: FC<PaginationProps> = ({page, pageSize, total, onChange, displayMode = 'page'}) => {
	const pages = useMemo(() => Math.ceil(total / pageSize), [pageSize, total]);

	const startItem = total === 0 ? 0 : (page - 1) * pageSize + 1;
	const endItem = Math.min(page * pageSize, total);

	const createHandleMenuClick = (page: number) => {
		onChange(page);
	};

	const handleNextPage = () => {
		onChange(page + 1);
	};
	const handlePrevPage = () => {
		onChange(page - 1);
	};

	return (
		<Box className={styles.wrapper}>
			<Button
				disableRipple
				startIcon={<ArrowLeftIcon />}
				variant={TEXT}
				disabled={page === defaultPage}
				className={cx(styles.arrow, styles.arrow__left, {[styles.arrow__disabled]: page === defaultPage})}
				onClick={handlePrevPage}
			/>

			{displayMode === 'range' ? (
				<Typography variant={BODY1} className={styles.dropdown__text}>
					{`${startItem}-${endItem} of ${total}`}
				</Typography>
			) : (
				<>
					<Typography>Page</Typography>
					<Box className={styles.dropdown}>
						<MuiDropdown>
							<MuiMenuButton className={styles.dropdown__button}>
								<Typography variant={BODY1} className={styles.dropdown__page}>
									{page} of {pages}
								</Typography>
								<div className={styles.dropdown__menu}>
									<ArrowUpIcon />
									<ArrowUpIcon />
								</div>
							</MuiMenuButton>

							<MuiMenu slots={{listbox: UL}} className={styles.listbox}>
								{Array.from({length: pages}, (_, index) => (
									<MuiMenuItem
										key={index}
										disabled={page === index + 1}
										onClick={() => createHandleMenuClick(index + 1)}
										className={cx(styles.listbox__item, {[styles.listbox__item_disabled]: page === index + 1})}
									>
										{index + 1}
									</MuiMenuItem>
								))}
							</MuiMenu>
						</MuiDropdown>
					</Box>
				</>
			)}

			<Button
				disableRipple
				startIcon={<ArrowRightIcon />}
				variant={TEXT}
				onClick={handleNextPage}
				disabled={page === pages}
				className={cx(styles.arrow, styles.arrow__right, {[styles.arrow__disabled]: page === pages})}
			/>
		</Box>
	);
};

// interface PaginationProps {
// 	page: number;
// 	pageSize: number;
// 	total: number;
// 	onChange: (page: number) => void;
// }

// const Pagination: FC<PaginationProps> = ({page, pageSize, total, onChange}) => {
// 	const pages = useMemo(() => Math.ceil(total / pageSize), [pageSize, total]);

// 	const createHandleMenuClick = (page: number) => {
// 		onChange(page);
// 	};

// 	const handleNextPage = () => {
// 		onChange(page + 1);
// 	};
// 	const handlePrevPage = () => {
// 		onChange(page - 1);
// 	};

// 	return (
// 		<Box className={styles.wrapper}>
// 			<Button
// 				disableRipple
// 				startIcon={<ArrowLeftIcon />}
// 				variant={TEXT}
// 				disabled={page === defaultPage}
// 				className={cx(styles.arrow, styles.arrow__left, {[styles.arrow__disabled]: page === defaultPage})}
// 				onClick={handlePrevPage}
// 			/>

// 			<Typography>Page</Typography>
// 			<Box className={styles.dropdown}>
// 				<MuiDropdown>
// 					<MuiMenuButton className={styles.dropdown__button}>
// 						<Typography variant={BODY1} className={styles.dropdown__page}>
// 							{page} of {pages}
// 						</Typography>
// 						<div className={styles.dropdown__menu}>
// 							<ArrowUpIcon />
// 							<ArrowUpIcon />
// 						</div>
// 					</MuiMenuButton>

// 					<MuiMenu slots={{listbox: UL}} className={styles.listbox}>
// 						{Array.from({length: pages}, (_, index) => (
// 							<MuiMenuItem
// 								key={index}
// 								disabled={page === index + 1}
// 								onClick={() => createHandleMenuClick(index + 1)}
// 								className={cx(styles.listbox__item, {[styles.listbox__item_disabled]: page === index + 1})}
// 							>
// 								{index + 1}
// 							</MuiMenuItem>
// 						))}
// 					</MuiMenu>
// 				</MuiDropdown>
// 			</Box>

// 			<Button
// 				disableRipple
// 				startIcon={<ArrowRightIcon />}
// 				variant={TEXT}
// 				onClick={handleNextPage}
// 				disabled={page === pages}
// 				className={cx(styles.arrow, styles.arrow__right, {[styles.arrow__disabled]: page === pages})}
// 			/>
// 		</Box>
// 	);
// };

export default Pagination;
